import type { ReactNode } from 'react';
import { Container, Text } from '@mantine/core';
import PageTitle from '@/components/common/PageTitle';
import classes from './StatusScreen.module.css';

interface StatusScreenProps {
  /** Короткая подпись над заголовком, например «Ошибка 404». */
  readonly kicker?: string;
  readonly title: string;
  readonly message: string;
  /** Что делать дальше: кнопки и ссылки в ряд. */
  readonly children?: ReactNode;
  /** Справка под тонкой линией, например контакты поддержки. */
  readonly help?: ReactNode;
}

// Экран вместо страницы: 404 и непредвиденная ошибка. Подпись, заголовок, что случилось, следующий шаг и справка.
// Выровнен влево по сетке 1240 px, как остальные разделы «Бюллетеня».
export default function StatusScreen({ kicker, title, message, children, help }: StatusScreenProps) {
  return (
    <Container size="lg" className={classes.screen}>
      {kicker ? <p className={classes.kicker}>{kicker}</p> : null}
      <PageTitle c="var(--mantine-color-text)" fz={{ base: 26, sm: 30 }}>
        {title}
      </PageTitle>
      <Text c="gray.7" className={classes.message}>
        {message}
      </Text>
      {children ? <div className={classes.actions}>{children}</div> : null}
      {help ? (
        <Text size="sm" c="gray.7" className={classes.help}>
          {help}
        </Text>
      ) : null}
    </Container>
  );
}
